import { Component, OnInit } from '@angular/core';
import { MapService } from './map.service';

@Component({
  selector: 'leaflet-map',
  standalone: false,
  template: '<div id="map" style="height: 495px"></div>',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {

  constructor(public mapService: MapService) {
  }

  ngOnInit() {
    this.mapService.initMap('map');
  }

}
